<nav
  class="fixed inset-x-0 z-40 h-12 overflow-visible border-b text-white"
  [style.top]="topOffset()"
  [style.background-color]="'var(--sidebar-bg)'"
  [style.border-color]="'var(--sidebar-border)'"
  aria-label="Menu principal"
>
  <div class="flex h-full items-center gap-1 px-2 sm:px-4">
    @for (item of navItems(); track item.label + item.route + (item.comingSoon ?
    '1' : '0')) { @if (hasChildren(item) && !item.route) {
    <div class="relative">
      <app-action-tooltip [label]="item.label" placement="bottom">
        <button
          type="button"
          class="inline-flex size-9 shrink-0 items-center justify-center rounded text-white/90 transition-colors hover:bg-white/15"
          [ngClass]="{
                'bg-white/20': isDescendantActive(item) || openGroupLabel() === item.label,
              }"
          [attr.aria-expanded]="openGroupLabel() === item.label"
          aria-haspopup="true"
          [attr.aria-label]="item.label"
          (click)="onGroupClick($event, item)"
        >
          <i
            class="bi text-base leading-none"
            [ngClass]="'bi-' + item.iconClass"
            aria-hidden="true"
          ></i>
        </button>
      </app-action-tooltip>

      @if (openGroupLabel() === item.label) {
      <div
        class="absolute left-0 top-full z-50 min-w-52 pt-1"
        role="menu"
        [attr.aria-label]="item.label"
        (click)="$event.stopPropagation()"
      >
        <div
          class="rounded border py-1 shadow-lg"
          [style.background-color]="'var(--sidebar-bg)'"
          [style.border-color]="'var(--sidebar-border)'"
        >
          @for (child of item.children; track child.label + child.route +
          (child.queryParams?.['role'] ?? '') + (child.queryParams?.['tab'] ??
          '')) {
          <a
            [routerLink]="child.route"
            [queryParams]="child.queryParams ?? {}"
            class="flex w-full items-center gap-2 px-3 py-2 text-sm text-white/90 transition-colors hover:bg-white/15"
            [ngClass]="{
                        'bg-white/20': isItemActive(child),
                        'font-semibold': isItemActive(child),
                      }"
            role="menuitem"
          >
            <i
              class="bi shrink-0 text-base leading-none"
              [ngClass]="'bi-' + child.iconClass"
              aria-hidden="true"
            ></i>
            <span>{{ child.label }}</span>
          </a>
          }
        </div>
      </div>
      }
    </div>
    } @else if (item.comingSoon) {
    <app-action-tooltip [label]="item.label + ' (em breve)'" placement="bottom">
      <span
        class="inline-flex size-9 shrink-0 cursor-not-allowed items-center justify-center rounded text-white/40"
        [attr.aria-label]="item.label + ' (em breve)'"
      >
        <i
          class="bi text-base leading-none"
          [ngClass]="'bi-' + item.iconClass"
          aria-hidden="true"
        ></i>
      </span>
    </app-action-tooltip>
    } @else {
    <app-action-tooltip [label]="item.label" placement="bottom">
      <a
        [routerLink]="item.route"
        [attr.aria-label]="item.label"
        class="inline-flex size-9 shrink-0 items-center justify-center rounded text-white/90 transition-colors hover:bg-white/15 focus:bg-white/15"
        [ngClass]="{
              'bg-white/20': isItemActive(item),
              'font-semibold': isItemActive(item),
            }"
      >
        <i
          class="bi text-base leading-none"
          [ngClass]="'bi-' + item.iconClass"
          aria-hidden="true"
        ></i>
      </a>
    </app-action-tooltip>
    } }
  </div>
</nav>
